import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { en, fr } from 'vuetify/locale'

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    locale: {
      locale: 'fr',
      fallback: 'en',
      messages: { fr, en },
    },
    theme: {
      // useDarkMode applies the user's choice once mounted; until then the app is light.
      defaultTheme: 'light',
      themes: {
        light: {
          colors: {
            primary: '#FFC107',
            secondary: '#212529',
            background: '#F5F5F5',
          }
        },
        dark: {
          colors: {
            primary: '#FFC107',
            secondary: '#212529'
          }
        }
      }
    },
    defaults: {
      VCard: {
        elevation: 0,
        border: true,
      },
      VTextField: {
        variant: 'outlined',
        density: 'comfortable',
      },
      VSelect: {
        variant: 'outlined',
        density: 'comfortable',
      },
      VAutocomplete: {
        variant: 'outlined',
        density: 'comfortable',
      },
      VTextarea: {
        variant: 'outlined',
        density: 'comfortable',
      },
    }
  })
  nuxtApp.vueApp.use(vuetify)
})
